
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M3.426 0a.529.529 0 00-.527.527v.79h-.84A2.06 2.06 0 000 3.377v8.536a2.06 2.06 0 002.058 2.058h9.063a2.061 2.061 0 002.058-2.058V3.376a2.061 2.061 0 00-2.058-2.058h-.843v-.79A.529.529 0 009.75 0a.529.529 0 00-.527.527v.79h-5.27v-.79A.529.529 0 003.426 0zm5.798 2.372v.79c0 .29.237.527.527.527.29 0 .527-.237.527-.527v-.79h.84c.554 0 1.004.45 1.004 1.004v8.536c0 .553-.45 1.004-1.004 1.004h-9.06a1.006 1.006 0 01-1.004-1.004V3.376c0-.554.45-1.004 1.004-1.004h.84v.79a.529.529 0 001.054 0v-.79h5.272z"}}),_c('circle',{attrs:{"cx":"3.689","cy":"6.588","r":"1"}}),_c('circle',{attrs:{"cx":"6.588","cy":"6.588","r":"1"}}),_c('circle',{attrs:{"cx":"9.487","cy":"6.588","r":"1"}}),_c('circle',{attrs:{"cx":"3.689","cy":"9.487","r":"1"}}),_c('circle',{attrs:{"cx":"6.588","cy":"9.487","r":"1"}}),_c('circle',{attrs:{"cx":"9.487","cy":"9.487","r":"1"}})])])
          )
        }
      }
    